import {AfterViewInit, Component, Input} from '@angular/core';
import {BestPerformingInfluencer} from '../../../../models/measure/report';
import {CommonConstant} from '../../../app.constants';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';
import {Router} from '@angular/router';
import {NumberUtils} from '../../../utils/number.utils';

@Component({
  selector: 'best-performing-influencer',
  templateUrl: './best-performing-influencer.component.html',
  styleUrls: ['./best-performing-influencer.component.scss']
})
export class BestPerformingInfluencerComponent implements AfterViewInit {

  static COMPONENT_NAME = 'BestPerformingInfluencerComponent';

  @Input()
  bestPerformingInfluencers: BestPerformingInfluencer[] = [];

  @Input()
  isSortedByReach: boolean;

  constructor(private pdfService: PdfExportService,
              private router: Router,
              private userService: UserService) {
  }

  ngAfterViewInit() {
    if (this.bestPerformingInfluencers.length === 0) {
      this.pdfService.incrementNumberReportReady(BestPerformingInfluencerComponent.COMPONENT_NAME);
      return;
    }

    this.pdfService.imagedLoadedTrigger.subscribe(data => {
      if (data.component === BestPerformingInfluencerComponent.COMPONENT_NAME
              && data.currentCounter === this.bestPerformingInfluencers.length) {
        console.log('all images of BestPerformingInfluencerComponent are loaded');
        this.pdfService.incrementNumberReportReady(BestPerformingInfluencerComponent.COMPONENT_NAME);
      }
    });
  }

  get topThreePerformingInfluencer() {
    // Not handle for empty list
    if (this.bestPerformingInfluencers.length === 0) {
      return [];
    }

    return this.bestPerformingInfluencers.slice(0, 3);
  }

  get remaningInfluencerExcludeTopThree() {
    // Not handle for empty list
    if (this.bestPerformingInfluencers.length === 0) {
      return [];
    }

    const numberOfInfluencer = this.bestPerformingInfluencers.length;
    return this.bestPerformingInfluencers.slice(3, numberOfInfluencer);
  }

  findCountryCode(influencer) {
    return influencer.country ? influencer.country.code : CommonConstant.INTERNATION_COUNTRY_CODE;
  }

  callbackImageLoaded() {
    this.pdfService.updateNumberImageLoaded(BestPerformingInfluencerComponent.COMPONENT_NAME);
  }

  get isExportingReport() {
    return this.pdfService.exportingPdf;
  }

  formattedMentionCount(mentionCount) {
    if (mentionCount <= 0) {
      return '-';
    }
    return NumberUtils.normalizeNumberToString(mentionCount);
  }

  openInfluencerDetails(influencerId) {
    return this.router.navigate([`/influencer/${influencerId}/overview`], {
      queryParams: {
        activeAccount: this.userService.getCompanyId()
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/best-performing-influencer/best-performing-influencer.component.ts